import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    ordenesSubtrabajos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    cliente: null,
    articuloTipo: null,
    proveedor: null,
    sortByDescending: true,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.ordenesSubtrabajos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.cliente = null;
        state.articuloTipo = null;
        state.proveedor = null;
        state.sortByDescending = true;
    },

    'INICIALIZAR_ORDENES' (state) {
        state.ordenesSubtrabajos = [];
    },
    'SET_ORDENES' (state, ordenesSubtrabajos) {
        state.ordenesSubtrabajos = ordenesSubtrabajos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getOrdenes ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDENES');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&sortByDescending='+ state.sortByDescending;
            
            if (state.cliente) {
                if (state.cliente.id) {
                    if (state.cliente.id != 0) {
                        queryString += '&clienteId=' + state.cliente.id;
                    }
                }
            }
            if (state.articuloTipo) {
                if (state.articuloTipo.id) {
                    if (state.articuloTipo.id != 0) {
                        queryString += '&articuloTipoId=' + state.articuloTipo.id;
                    }
                }
            }
            if (state.proveedor) {
                if (state.proveedor.id) {
                    if (state.proveedor.id != 0) {
                        queryString += '&proveedorId=' + state.proveedor.id;
                    }
                }
            }
            
            // apiAxios.get('ordenestrabajos/subtrabajos' + queryString)
            apiAxios.get('ordenesproveedores/subtrabajos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_ORDENES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },

    moverSubtrabajo ( {}, params ) {
        return new Promise((resolve, reject) => {
            let subtrabajoUpdate = {
                presupuestoInternoId: params.presupuestoInternoId,
                ordenTrabajoId: params.ordenTrabajoId,
                ordenSubtrabajoId: params.ordenSubtrabajoId
            }

            apiAxios.post('ordenestrabajos/subtrabajos/' + params.ordenSubtrabajoId + '/move' , subtrabajoUpdate)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}